import React, { useState, useEffect } from "react";
import { Card } from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

//Main components
import MenuButtons from "../PreviousConversations/subcomponents/MenuButtons";
import EngagementHistoryArea from "./subcomponents/EngagementHistoryArea.js";

const HistoryChats = ({ chats, isVisible, update, style }) => {
  const [updateFlag, setUpdateFlag] = useState(-1);

  useEffect(() => {
    update && setUpdateFlag((u) => u + 1);
  }, [update]);

  return (
    <Card className=" user-chat h-100 engagement-card" style={style}>
      <MenuButtons
        type="engagementHistory"
        isVisible={isVisible}
        onUpdate={() => {
          setUpdateFlag((e) => e + 1);
        }}
        consumerId={chats?.consumer}
        loadingData={chats?.status === "loading"}
      />
      <div
        className="chat-conversation h-100 pb-4"
        style={{
          overflow: "auto",
        }}
      >
        <PerfectScrollbar className="pt-0" id="engagementScroll">
          <ul className="list-unstyled mt-3">
            <EngagementHistoryArea chats={chats} update={updateFlag} />
          </ul>
        </PerfectScrollbar>
      </div>{" "}
    </Card>
  );
};
export default React.memo(HistoryChats);
